import { render, staticRenderFns } from "./CoursesAnalysis.vue?vue&type=template&id=732b6544"
import script from "./CoursesAnalysis.vue?vue&type=script&lang=js"
export * from "./CoursesAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports